import React, { useState } from 'react';
import './custom_css_js.scss';
import AceEditor from 'react-ace-builds';
import 'ace-builds/src-noconflict/theme-twilight';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/mode-javascript';
import { __ } from '@wordpress/i18n';
//import { nxtinstallCall } from '../../apicall';

//const plugin_url = nxtext_ajax_object.tpgb_url;
import { nxtdash_save_data } from '../../apicall';

const Custom_CSS_JS = () => {
    const [customCSS, setCustomCSS] = useState(nxtext_ajax_object.dashData.customCode.tpgb_custom_css_editor || '');
    const [customJS, setCustomJS] = useState(nxtext_ajax_object.dashData.customCode.tpgb_custom_js_editor || '');

    const handleSaveSettings = (e) => {
        e.preventDefault();

        nxtdash_save_data(e, {
            action: 'tpgb_custom_css_js_save',
            'submit-key': 'Save',
            tpgb_custom_css_editor: customCSS || '',
            tpgb_custom_js_editor: customJS || '',
            nonce_tpgb_custom_css_js: nxtext_ajax_object.ajax_nonce,
        });
    };

    return (
        <div className='nxt_custom_css_js_inner_main'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{__('Custom CSS & JS', 'nexter-extension')}</h3>

                <div className='nxt_header_toggle_btn_group'>
                    <a href='#' className='nxt_blue_common_btn nxt-btn-fix' onClick={handleSaveSettings}>{__('Save Settings', 'nexter-extension')}</a>
                </div>
            </div>

            <div className='nxt_custome_code_cover'>
                <div className='nxt_inner_section_heading'>{__('Custom CSS', 'nexter-extension')}</div>
                <div className='custom_css_editor' >
                    <AceEditor
                        mode='css'
                        theme='twilight'
                    
                        onChange={setCustomCSS}
                        fontSize={14}
                        showPrintMargin={true}
                        showGutter={true}
                        value={customCSS}
                        setOptions={{
                            enableBasicAutocompletion: false,
                            enableLiveAutocompletion: false,
                            enableSnippets: false,
                            showLineNumbers: true,
                            tabSize: 2,
                            useWorker: false,
                        }}
                        style={{
                            width: '100%',
                            height: '300px',
                            border: '1px solid #ddd',
                            borderRadius: '5px',
                        }}
                    />
                </div>
                <p className='nxt_warning_text'>{__('Add Your Custom CSS Styles', 'nexter-extension')}</p>
            </div>

            <div className='nxt_custome_code_cover'>
                <div className='nxt_inner_section_heading'>{__('Custom JS', 'nexter-extension')}</div>
                <div className='custom_css_editor' >
                    <AceEditor
                        mode='javascript'
                        theme='twilight'
                        className='custom_css_editor's
                        onChange={setCustomJS}
                        fontSize={14}
                        showPrintMargin={true}
                        showGutter={true}
                        value={customJS}
                        setOptions={{
                            enableBasicAutocompletion: false,
                            enableLiveAutocompletion: false,
                            enableSnippets: false,
                            showLineNumbers: true,
                            tabSize: 2,
                            useWorker: false,
                        }}
                        style={{
                            width: '100%',
                            height: '300px',
                            border: '1px solid #ddd',
                            borderRadius: '5px',
                        }}
                    />
                </div>
                <p className='nxt_warning_text'>{__('Add Your Custom JS Script', 'nexter-extension')}</p>
            </div>

            {/* <div className='nxt_custom_infobox_cover'>
                <img src={plugin_url + 'assets/svg/nxt_info_icon.svg'} draggable={false} />
                <div className='nxt_info_content'>
                    <h4 className='nxt_warning_text nxt_sec_h'>{__('Need more than CSS & JS?', 'nexter-extension')}</h4>
                    <p className='nxt_warning_text'>{__('Add PHP, HTML, CSS & JS Code Snippets with conditional rules for FREE using our Nexter Extension', 'nexter-extension')}</p>
                    
                    <div className='nxt_header_toggle_btn_group'>
                    { !nxtext_ajax_object.dashData.nexterext ?
                        <button onClick={(e) => nxtinstallCall(e)} className='nxt_blue_common_btn nxt-ext-inbtn'>{__('Enable Code Snippets', 'nexter-extension')}</button>
                        : 
                        <a href='edit.php?post_type=nxt_builder' target="_blank" rel="noopener noreferrer" className='nxt_blue_common_btn'>{ __('Open Code Snippets' , 'nexter-extension') }</a>
                    }
                </div>
                </div>
            </div> */}
        </div>
    );
};

export default Custom_CSS_JS;